module.exports = __webpack_public_path__ + "static/media/icon-user-group-large.0e3ebd36.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-user-group-large.svg
// module id = 1724
// module chunks = 0